import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SideNav from 'components/layout-components/SideNav';
import TopNav from 'components/layout-components/TopNav';
import Loading from 'components/shared-components/Loading';
import MobileNav from 'components/layout-components/MobileNav'
import HeaderNav from 'components/layout-components/HeaderNav';
import PageHeader from 'components/layout-components/PageHeader';
import Footer from 'components/layout-components/Footer';
import AppViews from 'views/app-views';
import {
  Layout,
  Grid,
} from "antd";

import navigationConfig from "configs/NavigationConfig";
import { 
  SIDE_NAV_WIDTH, 
  SIDE_NAV_COLLAPSED_WIDTH,
  NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  DIR_RTL,
  DIR_LTR
} from 'constants/ThemeConstant';
import utils from 'utils';
import { useThemeSwitcher } from "react-css-theme-switcher";
import { SOCKET_URL } from 'configs/AppConfig';
import {getAdminUserData} from 'redux/actions/Auth';
const io = require('socket.io-client')


const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, location, direction, adminUserData, navigationConfig, attendanceData }) => {
	
	const currentRouteInfo = utils.getRouteInfo(navigationConfig, location.pathname)
	const screens = utils.getBreakPoint(useBreakpoint());
	const isMobile = !screens.includes('lg')
	const isNavSide = navType === NAV_TYPE_SIDE
	const isNavTop = navType === NAV_TYPE_TOP	
	
	const getLayoutGutter = () => {
		if(isNavTop || isMobile) {
			return 0
		}
		return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
	}

	const { status } = useThemeSwitcher();
	var socket; 
	if (status === 'loading') {
		return <Loading cover="page" />;
	}
	

	if (status === 'loaded') {	      
			socket = io.connect(SOCKET_URL, { transports : ['websocket'] });		
			console.log(SOCKET_URL)
	}

	const getLayoutDirectionGutter = () => {
		if(direction === DIR_LTR) {
		return {paddingLeft: getLayoutGutter()}
		}  
		if(direction === DIR_RTL) {
		return {paddingRight: getLayoutGutter()}
		}
		return {paddingLeft: getLayoutGutter()}
	}

	return (
		<Layout>
			<HeaderNav isMobile={isMobile} socket={socket} navigationConfig={navigationConfig} adminUserData={adminUserData} attendanceData={attendanceData}/>
			{(isNavTop && !isMobile) ? <TopNav routeInfo={currentRouteInfo}/> : null}
			<Layout className="app-container">
				{(isNavSide && !isMobile) ? <SideNav routeInfo={currentRouteInfo} socket={socket} navigationConfig={navigationConfig} adminUserData={adminUserData}/> : null }
				<Layout className="app-layout test" style={getLayoutDirectionGutter()}>
				<div className={`app-content ${isNavTop ? 'layout-top-nav' : ''}`}>
					<PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title} />
					{
						status === 'loaded' &&
						<Content>
							<AppViews socket={socket}/>
						</Content>
					}
				</div>
				<Footer />
				</Layout>
			</Layout>
		{isMobile && <MobileNav socket={socket} navigationConfig={navigationConfig} adminUserData={adminUserData}/>}
		</Layout>
	)
}

const mapStateToProps = ({ theme, auth }) => {
  const { navCollapsed, navType, locale } =  theme;
  const { userData } = auth;
  return { navCollapsed, navType, locale, userData }
};
const mapDispatchToProps = {
	getAdminUserData
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AppLayout));